export default "__VITE_ASSET__1BGE8J6J__"